import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = () => (
  <div style={{ textAlign: "center", marginTop: "3em" }}>
    <CircularProgress />
  </div>
);

export default Loading;
